/**
 * Filter objects to a query string.
 *
 * Blank values are DROPPED rather than sent as empty strings. The API validates
 * `status` as an enum, and `?status=` fails that check - so a user clearing the
 * status filter would get a validation error instead of an unfiltered list. Same for
 * `false`, which every boolean filter here treats as "not applied".
 */
export function toQuery(filters: object): string {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(filters)) {
    if (value === undefined || value === null || value === '' || value === false) continue;
    params.set(key, String(value));
  }
  const query = params.toString();
  return query ? `?${query}` : '';
}
